import {useGetPatientGfrLabs} from '@/modules/patients/api/use-get-patient-gfr-labs'
import {formatGfr} from '@/modules/patients/functions'
import {Button, ButtonGroup, Text} from '@chakra-ui/react'
import {PatientGfr} from '@cypro/engine/schema'
import {dialog, DialogBody, DialogFooter, DialogHeader} from '@cypro/ui/components'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {formatDateKey, getDatetimeFormatter} from '@cypro/ui/utils'
import {useTranslate} from '@tolgee/react'

export function getDeleteGfrDialogId(gfrId: string) {
  return `delete-gfr-${gfrId}`
}

export function DeleteGfrDialog({gfr}: {gfr: PatientGfr}) {
  const {t} = useTranslate('common')
  const [gfrLabs] = useGetPatientGfrLabs(gfr.patientId)
  const id = getDeleteGfrDialogId(gfr.id)

  // The list is ordered like the in-use rule, so the first remaining value is the one in use after deleting.
  const inUseAfterDeleting = gfrLabs.find(lab => lab.id !== gfr.id)

  return (
    <>
      <DialogHeader>{t('gfr.delete_dialog.title')}</DialogHeader>

      <DialogBody minHeight="none" spaceY="4">
        <Text>{t('gfr.delete_dialog.description')}</Text>
        <DataList
          items={[
            {label: t('gfr_table.sample_date'), value: formatDateKey(gfr.labTime)},
            {label: t('gfr_table.calculation_method'), value: t(`gfr.${gfr.method}`)},
            {label: t('gfr_table.gfr'), value: formatGfr(gfr.gfr)},
            {
              label: t('gfr_table.entered_on'),
              value: gfr.createdAt ? getDatetimeFormatter().format(gfr.createdAt) : '-',
            },
            {
              label: t('gfr.delete_dialog.in_use_after'),
              value: inUseAfterDeleting ? `${formatGfr(inUseAfterDeleting.gfr)} ${t('ml_min')}` : '-',
            },
          ]}
        />
      </DialogBody>

      <DialogFooter>
        <ButtonGroup size="md" width="100%" justifyContent="flex-end">
          <Button variant="outline" colorPalette="gray" onClick={() => void dialog.close(id, false)}>
            {t('gfr.delete_dialog.keep')}
          </Button>
          <Button colorPalette="red" onClick={() => void dialog.close(id, true)}>
            {t('delete')}
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </>
  )
}
